import {DependencyList, useEffect, useRef} from 'react';

const useNonInitialEffect = (func: () => void, deps: DependencyList): void => {
  const didMount = useRef(false);

  useEffect(() => {
    if (didMount.current) {
      func();
    } else {
      didMount.current = true;
    }
  }, deps);
};

export default useNonInitialEffect;
